export default {
  income: 'invoicing.view_income_link_overview',
  expense: 'invoicing.view_expense_link_overview',
};
